import "../Styles/Banner.css"
function Banner({children}){
return <>{children}</>

}
export default Banner